import React, { useEffect } from "react"
import { Col, Container, Row } from "reactstrap"
import { useLocation } from "react-router-dom"
import EmailSideBar from "./EmailSideBar"
import { getEmail, getEmailThread } from "store/actions/Emails";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { RootState } from "store/store"
import WaitingDots from "components/WaitingDots"
import { GetRouterQuery } from "components/Utils/GetRouterQuery";
import EmailCard from "./EmailCard";
import PageMeta from "components/PageMeta";
import { EmailState } from 'store/reducers/Emails';
import WhatsappCompose from "./WhatsappCompose";
import { useOfficeTranslation } from "i18n/OfficeTranslation";


interface Props {
  emailState: EmailState;
}

interface Actions {
  getEmail: (id: string) => void;
  getEmailThread: (id: string) => void;
}

const EmailView: React.FC<Props & Actions> = ({ emailState, getEmail, getEmailThread }) => {
  const { t } = useOfficeTranslation();
  const location = useLocation();

  const { id } = GetRouterQuery<{ id: string }>()

  useEffect(() => {
    getEmail(id)
    getEmailThread(id)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (emailState.getEmailById(id) === null) {
    return <WaitingDots />
  }

  const email = emailState.getEmailById(id)

  return (
    <>
      <div className="page-content">
        <PageMeta title={`${emailState.getEmailById(id)?.subject} | ${t("email.emailView.emails")}`} />
        <Container fluid>
          <Row>
            <Col xs="12">
              <EmailSideBar box={""} unread={emailState.getEmails()
                .filter(email => email.direction === "in" && !email.IsRead()).length} />
              <div className="email-rightbar mb-3">
                {(location.state as { composed?: boolean } | null)?.composed && email?.status === "queued" && <div className="alert alert-success" role="status">{t("email.composer.queued")}</div>}
                {(email !== null && email.type === "whatsapp") && <WhatsappCompose reply_id={email.id} />}
                <EmailCard id={id} />
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  )
}

const mapStateToProps = (state: RootState) => {
  return {
    emailState: state.Emails
  };
};


const mapDispatchToProps = (dispatch: any) => {
  return bindActionCreators({ getEmail, getEmailThread }, dispatch);
};


export default connect(mapStateToProps, mapDispatchToProps)(EmailView);
